module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MediaGridItemSmugmug"
  }, [_c('smugmug-album-thumbnail', {
    attrs: {
      "album-key": _vm.data['smugmug-album'],
      "image": _vm.data.image,
      "route": _vm.data.route,
      "ratio": _vm.data.ratio,
      "large": _vm.large
    }
  }), _vm._v(" "), _c('media-grid-item-title', {
    attrs: {
      "data": _vm.data
    }
  }), _vm._v(" "), _c('media-grid-item-description', {
    attrs: {
      "data": _vm.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83450256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemSmugmug.vue
// module id = 786
// module chunks = 1474